import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// v4.5.8 — global theme palette. The cached value is applied immediately to
// avoid a flash, then refreshed from the saved `theme_palette` setting.
const THEMES = ["default", "corporate-blue", "slate", "sand"];
const applyTheme = (name) => {
  const theme = THEMES.includes(name) ? name : "default";
  document.documentElement.dataset.theme = theme;
  try { localStorage.setItem("theme_palette", theme); } catch { /* ignore */ }
};
try { applyTheme(localStorage.getItem("theme_palette")); } catch { applyTheme("default"); }
fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
  .then((r) => r.json())
  .then((d) => applyTheme(d?.theme_palette))
  .catch(() => {});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
